import { OrganisationMember } from '@ih/app/shared/apis/interfaces';

export class FindAllDefaultRoles {
  public static readonly type =
    '[Organisation/OrganisationMember/List] FindAllDefaultRoles';
  constructor(public readonly organisationMembers: OrganisationMember[]) {}
}
